import { useEffect, useState } from "react";
import { fetchCharidyCampaign, fetchCharidyDonations } from "../service/charidy";

const POLL_MS = 60000; // Charidy caches ~10s server-side; 60s is polite and feels live.

export default function useCharidyCampaign(shortlink) {
  const [campaign, setCampaign] = useState(null);
  const [donations, setDonations] = useState([]);
  const [donorCount, setDonorCount] = useState(null);

  useEffect(() => {
    if (!shortlink) return undefined;
    let cancelled = false;
    let timer = null;

    const poll = async () => {
      try {
        const c = await fetchCharidyCampaign(shortlink);
        if (cancelled) return;
        const { donations: list, donorCount: count } = await fetchCharidyDonations(c.campaignId);
        if (cancelled) return;
        setCampaign(c);
        setDonations(list);
        setDonorCount(count);
      } catch {
        // Charidy being down must never break the site; keep whatever we had.
      }
      if (!cancelled) {
        timer = setTimeout(poll, POLL_MS);
      }
    };

    poll();
    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [shortlink]);

  return { campaign, donations, donorCount };
}
